import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import some from "lodash/some";
import isEmpty from "lodash/isEmpty";
import { logoutUser } from '../../app-main/actions/auth';
import publicConfig from '../../../../public-config';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { LocaleSelector } from 'shared-components/internationalization/locale-selector';
import { SearchSmall, ArrowDownSmall } from 'shared-components/icons';
import { signinUrlFromNav, signupUrlFromNav } from 'shared-components/utils/navigation.utils';
import { Tooltip } from 'shared-components/tooltip/tooltip';
import {
  VENDOR_LISTINGS_TOOLTIP_MAX_SHOWS,
  VENDOR_LISTINGS_TOOLTIP_SHOWN_COUNT_COOKIE_EXPIRY_MS,
  VENDOR_LISTINGS_TOOLTIP_HIDDEN_COOKIE_EXPIRY_MS,
  NAVBAR_COLLAPSED_QUERY,
  getVendorListingsTooltipShownCountCookieName,
  getVendorListingsTooltipHiddenCookieName
} from 'shared-components/navbar/vendor-listings-tooltip.utils';

class DefaultNav extends Component {
  constructor (props) {
    super(props);

    this.state = {
      hasMounted: false,
      isNavCollapsed: false,
      listingsTooltipDismissed: false
    };
    this.listingsTooltipShown = false;

    this.logout = this.logout.bind(this);
    this.incrementVendorListingsTooltipShownCount = this.incrementVendorListingsTooltipShownCount.bind(this);
    this.suppressListingsTooltip = this.suppressListingsTooltip.bind(this);
    this.handlePageHide = this.handlePageHide.bind(this);
  }

  componentDidMount () {
    this.setState({
      hasMounted: true,
      isNavCollapsed: window.matchMedia(NAVBAR_COLLAPSED_QUERY).matches
    });
    // most nav links are plain <a href> full-page navigations, so componentDidUpdate's
    // pathname check never runs for them (the page unloads before React can react) - pagehide
    // fires synchronously before that unload, so it catches the case componentDidUpdate misses
    window.addEventListener('pagehide', this.handlePageHide);
  }

  componentWillUnmount () {
    window.removeEventListener('pagehide', this.handlePageHide);
  }

  componentDidUpdate (prevProps) {
    const prevPathname = get(prevProps, 'location.pathname');
    const pathname = get(this.props, 'location.pathname');

    // close the tooltip and suppress it for a day once the user navigates away from the page it was shown on
    if (pathname !== prevPathname && this.listingsTooltipShown) {
      this.suppressListingsTooltip();
    }
  }

  handlePageHide () {
    if (this.listingsTooltipShown) {
      this.suppressListingsTooltip();
    }
  }

  logout (e) {
    e.preventDefault();
    const { dispatch } = this.props;

    dispatch(logoutUser());
  }

  sendReferralNavClickAnalytics () {
    analyticsIntegrations.trackReferralClick('nav');
  }

  incrementVendorListingsTooltipShownCount () {
    const { profile } = this.props;
    const { SSOid } = profile;
    if (!SSOid) return;
    const cookieName = getVendorListingsTooltipShownCountCookieName(SSOid);
    const shownCount = Number(PSSessions.Cookies(cookieName)) || 0;

    PSSessions.Cookies.set(cookieName, shownCount + 1, { expires: new Date(Date.now() + VENDOR_LISTINGS_TOOLTIP_SHOWN_COUNT_COOKIE_EXPIRY_MS) });
  }

  // close the tooltip and suppress it for a day, whether from an explicit dismiss (the tooltip's X button) or a navigation away
  suppressListingsTooltip () {
    const { profile } = this.props;
    const { SSOid } = profile;

    this.setState({ listingsTooltipDismissed: true });
    if (SSOid) {
      PSSessions.Cookies.set(
        getVendorListingsTooltipHiddenCookieName(SSOid),
        true,
        { expires: new Date(Date.now() + VENDOR_LISTINGS_TOOLTIP_HIDDEN_COOKIE_EXPIRY_MS) }
      );
    }
  }

  renderImage () {
    const { profile } = this.props;
    const { data } = profile;

    if (data && data.avatar_url) {
      return <img className="img-circle" src={data.avatar_url} />;
    }

    return <img className="img-circle" src="/web-2/assets/images/no_avatar_placeholder.svg?v=rb" />;
  }

  renderSearch () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    return (
      <li>
        <a id="header_link_search" className="search" onClick={() => this.props.toggleSearchWidgetFn()} >
          <SearchSmall className="margin-sm-right" width={20} height={20} />
          <FormattedMessage id='shared_component.nav.search' defaultMessage='Search'/>
        </a>
      </li>
    );
  }

  renderMessages () {
    const { nav } = this.props;

    if (nav.messageCount) {
      return <span className="menu-message-bubble">{ nav.messageCount }</span>;
    }

    return null;
  }

  renderListings (isBoxMenu) {
    const { profile, nux = {} } = this.props;
    const { data, SSOid } = profile;
    const listClass = isBoxMenu ? 'visible-menu-item' : 'menu-listings hidden-menu-item';
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'mylistings-new-badge' });

    // vendor functionality to show 'listings' in the nav if vendor but not host
    // shows on any page, if not suppressed for the day, and if tooltip has not been shown more than 3 times
    const isVendor = data.is_vendor || data.vendor;
    const isTooltipHidden = !!PSSessions.Cookies(getVendorListingsTooltipHiddenCookieName(SSOid));
    const tooltipShownCount = Number(PSSessions.Cookies(getVendorListingsTooltipShownCountCookieName(SSOid))) || 0;
    const showTooltip = isVendor && !isBoxMenu && !this.state.isNavCollapsed && !isTooltipHidden &&
      !this.state.listingsTooltipDismissed && tooltipShownCount < VENDOR_LISTINGS_TOOLTIP_MAX_SHOWS;
    if (!isBoxMenu) {
      this.listingsTooltipShown = showTooltip;
    }
    const listingsLink = (
      <a className="nav-link text-white" href="/mylistings">
        <FormattedMessage id='shared_component.nav.listings' defaultMessage='Listings'/>
      </a>
    );

    if (data && (data.is_host || isVendor)) {
      return (
        <li className={listClass}>
          {
            showTooltip ?
              <Tooltip
                id="vendor_listings_nav_tooltip"
                anchorType="custom"
                placement="bottom"
                tooltipClass="vendor-listings-tooltip"
                customAnchor={listingsLink}
                showX
                openOnRender
                openCB={this.incrementVendorListingsTooltipShownCount}
                closeXCB={this.suppressListingsTooltip}
              >
                <span>
                  <span className="vendor-listings-tooltip-new">
                    <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
                  </span>
                  {' '}
                  <FormattedMessage id='shared_component.nav.vendor_listings_tooltip' defaultMessage='Manage your service listing here anytime.'/>
                </span>
              </Tooltip> :
              listingsLink
          }
          {
            badgeExp &&
            <span className="v-center text-pale-blue text-small new-notification">
              <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
            </span>
          }
        </li>
      );
    }
    return null;
  }

  renderBoards (isBoxMenu) {
    const { profile } = this.props;
    const { data } = profile;
    if (data) {
      const listClass = !isBoxMenu ? 'menu-listings hidden-menu-item' : data.is_host ? '' : 'visible-menu-item';
      if (!data.is_host || isBoxMenu) {
        return (
          <li className={listClass}>
            <a href='/boards'>
              <FormattedMessage id='shared_component.nav.boards' defaultMessage='Boards'/>
            </a>
          </li>
        );
      }
    }
    return null;
  }

  renderCalendar (isBoxMenu) {
    const { profile = {}, nux = {} } = this.props;
    const { data = {} } = profile;
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'calendar-new-badge' });
    const listClass = isBoxMenu ? 'visible-menu-item' : 'hidden-menu-item';
    if (data && data.is_host) {
      return (
        <li className={`menu-calendar ${listClass}`}>
          <a className="nav-link" href="/calendar">
            <FormattedMessage id='shared_component.nav.calendar' defaultMessage='Calendar'/>
          </a>
          {
            badgeExp ?
              <span className="v-center text-pale-blue text-small new-notification">
                <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
              </span> : null
          }
        </li>
      );
    }
    return null;
  }

  renderAddons (isBoxMenu) {
    const { profile = {}, nux = {} } = this.props;
    const { data = {} } = profile;
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'addons-new-badge' });
    const listClass = isBoxMenu ? 'visible-menu-item' : 'hidden-menu-item';
    if (data && data.is_host) {
      return (
        <li className={`menu-item ${listClass}`}>
          <a className="nav-link" href="/hosting/add-ons">
            <FormattedMessage id='shared_component.nav.add_ons' defaultMessage='Add-ons'/>
          </a>
          {
            badgeExp &&
            <span className="v-center text-pale-blue text-small new-notification">
              <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
            </span>
          }
        </li>
      );
    }
    return null;
  }

  renderHostForum (isBoxMenu) {
    const { profile } = this.props;
    const { data } = profile;
    const listClass = isBoxMenu ? 'hidden-lg' : 'visible-lg visible-xl';

    if (data && data.is_host) {
      return (
        <li className={`menu-forum ${listClass}`}>
          <a href="https://community.peerspace.com"><FormattedMessage id='shared_component.nav.community' defaultMessage='Community'/></a>
        </li>
      );
    }

    return null;
  }

  renderPayoutError (isMobile) {
    const { nav, profile, location } = this.props;
    const { data, bankStatus } = profile;
    const { managedAccount } = nav;
    const detailsSubmitted = get(managedAccount, 'details_submitted');
    const combinedRequirements = get(managedAccount, 'combined_requirements');
    const bankAcctSubmitted = 1 <= (get(managedAccount, 'external_accounts.data') || []).length;
    const listClass = isMobile ? 'visible-sm visible-xs visible-md visible-lg' : 'hidden-xs hidden-sm hidden-md hidden-lg';
    const newHost = managedAccount && (!detailsSubmitted || !bankAcctSubmitted);
    const peerspaceCanDistributeHostFunds = !('manual' === get(managedAccount, 'settings.payouts.schedule.interval'));
    const hostNeedsToEnablePayout = managedAccount && (!managedAccount.payouts_enabled || !peerspaceCanDistributeHostFunds) && !isEmpty(combinedRequirements);

    if (newHost) {
      return (
        <li className={`menu-add-payout-info ${listClass}`}>
          <a href="/account/host">
            <FormattedMessage id='shared_component.nav.add_payout' defaultMessage='Add Payout Info'/>
          </a>
        </li>
      );
    } else if (hostNeedsToEnablePayout || data.external_accounts_error) {
      return (
        <li className={`menu-payouts-blocked ${listClass}`}>
          <a href={data.external_accounts_error ? '/account/methods' : '/account/verify'}>
            <i className="ico icon-attention" /><FormattedMessage id='shared_component.nav.payout_blocked' defaultMessage='Payouts Blocked'/>
          </a>
        </li>
      );
    }

    return null;
  }

  renderReferral (showReferral) {
    if (showReferral) {
      return (
        <li className="menu-item hidden-menu-item" onClick={this.sendReferralNavClickAnalytics}>
          <a className="earn-more" href="/referrals" id="header_link_referrals">
            <img style={{ width: 20, marginBottom: 6 }}
              className="margin-md-right"
              src="https://assets.peerspace.com/gift-primary.svg?v=rb"
              alt={this.props.intl.formatMessage({ id: 'shared_component.nav.earn_50_alt', defaultMessage: 'gift' })}
            />
            <span><FormattedMessage id='shared_component.nav.earn_50' defaultMessage='Earn $50'/></span>
          </a>
        </li>
      );
    }
    return null;
  }

  renderControls () {
    const { accessToken, profile, intl, envLocaleData } = this.props;
    const isHost = get(profile, 'data.is_host');
    const isBlackListLanguage = 'en-US' !== intl.locale;
    const showReferral = !publicConfig.hideReferral && !isBlackListLanguage && !profile.isFetching && profile.hasFetched && !isHost;
    const showReferralForHost = !publicConfig.hideReferral && !isBlackListLanguage && !profile.isFetching && profile.hasFetched;
    const prefix = SharedIntlProviderHOC.getUrlPrefix();
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    const loginUrl = signinUrlFromNav(prefix);
    const signupUrl = signupUrlFromNav(prefix);

    if (accessToken) {
      return (
        <ul className="nav navbar-nav navbar-right nav-logged-in" id="navbar-right">
          <li>
            <a>
              <LocaleSelector source="navbar" activeLocales={envLocaleData}>
                <img width={20} height={20} className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
              </LocaleSelector>
            </a>
          </li>
          { isHost &&
            <li className="hidden-menu-item">
              <a id="nav-host-hub-link" href="/host-hub">
                <FormattedMessage id='shared_component.navbar.host_hub_nav_item' defaultMessage='Host hub'/>
                <span className="host-hub-badge">
                  <FormattedMessage id='shared_component.navbar.notification_nav_badge' defaultMessage='NEW!'/>
                </span>
              </a>
            </li>
          }
          { this.renderPayoutError(false) }
          { this.renderReferral(showReferral) }
          <li className="menu-messages hidden-menu-item">
            <a href="/inbox">
              <FormattedMessage id='shared_component.nav.inbox' defaultMessage='Inbox'/>
              { this.renderMessages() }
            </a>
          </li>
          <li className="menu-bookings hidden-menu-item"><a href='/bookings'><FormattedMessage id='shared_component.nav.bookings' defaultMessage='Bookings'/></a></li>
          { this.renderListings() }
          { this.renderCalendar() }
          { this.renderAddons() }
          { this.renderBoards() }
          { this.renderHostForum() }
          <li id="profileDropdown" className="dropdown profile-dropdown">
            <a href="#" className="dropdown-toggle profile-menu text-white" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              { this.renderImage() }
              <ArrowDownSmall width={24} height={24}/>
            </a>
            <ul className="dropdown-menu dropdown-menu-right profile-menu-dropdown">
              { this.renderPayoutError(true) }
              <div className="arrow-up"></div>
              { isHost &&
                <li className="visible-menu-item">
                  <a href="/host-hub">
                    <FormattedMessage id='shared_component.navbar.host_hub_nav_item' defaultMessage='Host hub'/>
                    <span className="host-hub-badge">
                      <FormattedMessage id='shared_component.navbar.notification_nav_badge' defaultMessage='NEW!'/>
                    </span>
                  </a>
                </li>
              }
              <li className="visible-menu-item">
                <a href="/inbox">
                  <FormattedMessage id='shared_component.nav.inbox' defaultMessage='Inbox'/>
                  { this.renderMessages() }
                </a>
              </li>
              <li className="visible-menu-item"><a href='/bookings'><FormattedMessage id='shared_component.nav.bookings' defaultMessage='Bookings'/></a></li>
              { this.renderListings(true) }
              { this.renderCalendar(true) }
              { this.renderAddons(true) }
              { this.renderHostForum(true) }
              <li><a href="/reviews/about-you"><FormattedMessage id='shared_component.nav.reviews' defaultMessage='Reviews'/></a></li>
              { this.renderBoards(true) }
              <li><a href="/profile"><FormattedMessage id='shared_component.nav.profile' defaultMessage='Profile'/></a></li>
              <li><a href="/account"><FormattedMessage id='shared_component.nav.payments' defaultMessage='Payments'/></a></li>
              {
                showReferralForHost
                && [
                  <li role="separator" className={`divider ${!isHost && "visible-xs"}`} />,
                  <li className={`${!isHost && "visible-xs"}`} onClick={this.sendReferralNavClickAnalytics}>
                    <a className="earn-more" href='/referrals' id="menu_link_referrals">
                      <img style={{ width: 20, marginBottom: 6 }}
                        className="margin-md-right"
                        src="https://assets.peerspace.com/gift-primary.svg?v=rb"
                        alt={this.props.intl.formatMessage({ id: 'shared_component.nav.earn_50_alt', defaultMessage: 'gift' })}
                      />
                      <span><FormattedMessage id='shared_component.nav.earn_50' defaultMessage='Earn $50'/></span>
                    </a>
                  </li>
                ]
              }
              <li role="separator" className="divider"></li>
              <li><a className="add-a-space-menu" href="/your-space"><FormattedMessage id='shared_component.nav.add_space' defaultMessage='Add a Space'/></a></li>
              <li><a href={`https://support.peerspace.com/hc/${zendeskLocale}`}><FormattedMessage id='shared_component.nav.help' defaultMessage='Help'/></a></li>
              <li>
                <a className="logout" onClick={ this.logout }><FormattedMessage id='shared_component.nav.logout' defaultMessage='Log Out'/></a>
              </li>
            </ul>
          </li>
        </ul>
      );
    }

    return (
      <ul className="nav navbar-nav navbar-right nav-logged-out">
        <li>
          <a>
            <LocaleSelector source="navbar" activeLocales={envLocaleData}>
              <img width={20} height={20} className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
            </LocaleSelector>
          </a>
        </li>
        <li>
          <a id="header_link_add_space" className="add-a-space" href="/host">
            <span><FormattedMessage id='shared_component.nav.list_space' defaultMessage='List Your Space'/></span>
          </a>
        </li>
        <li>
          <a id="header_link_signup" href={`${signupUrl}`}><FormattedMessage id='shared_component.nav.signup' defaultMessage='Sign Up'/></a>
        </li>
        <li>
          <a id="header_link_signin" href={`${loginUrl}`}><FormattedMessage id='shared_component.nav.login' defaultMessage='Log In'/></a>
        </li>
      </ul>
    );
  }

  renderCollapse () {
    const { profile } = this.props;

    if (profile) {
      return (
        <div>
          <button type="button" id="navbar-mobile-button" className="logged-in navbar-toggle text-white" data-toggle="collapse" data-target="#listing-navbar" aria-expanded="false">
            <span className="sr-only"><FormattedMessage id='shared_component.nav.toggle_nav' defaultMessage='Toggle navigation'/></span>
            { this.renderImage() }
            <ArrowDownSmall width={24} height={24}/>
          </button>
        </div>
      );
    }

    return (
      <div>
        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#listing-navbar" aria-expanded="false">
          <span className="sr-only"><FormattedMessage id='shared_component.nav.toggle_nav' defaultMessage='Toggle navigation'/></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </div>
    );
  }

  render () {
    const { hasMounted } = this.state;
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    return (
      <div className="container-fluid">
        <div className="navbar-header">
          { this.renderCollapse() }
          <a id="header_link_home" className="navbar-brand" href={`/${urlPrefix}`}>
              <img className="brand-logo-white" src="/web-2/assets/images/ps_logo_white.svg?v=rb" alt={this.props.intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })} />
              <img className="brand-logo-dark" src="/web-2/assets/images/ps_logo_dark.svg?v=rb" alt={this.props.intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })} />
          </a>
          <ul id="navbar-search" className="nav navbar-nav pull-right">
            { this.renderSearch() }
          </ul>
        </div>

        <div className="collapse navbar-collapse" id="listing-navbar">
          { hasMounted && this.renderControls() }
        </div>
      </div>
    );
  }
}

DefaultNav.propTypes = {
  accessToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  nav: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  nux: PropTypes.object.isRequired,
  location: PropTypes.object,
  intl: intlShape,
  envLocaleData: PropTypes.object
};

export default injectIntl(DefaultNav);
